import { render, staticRenderFns } from "./GuidesPage.vue?vue&type=template&id=2f9012de&scoped=true&lang=pug&"
import script from "./GuidesPage.vue?vue&type=script&lang=js&"
export * from "./GuidesPage.vue?vue&type=script&lang=js&"
import style0 from "./GuidesPage.vue?vue&type=style&index=0&id=2f9012de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9012de",
  null
  
)

export default component.exports